import { useQuery } from 'react-query';
import * as api from 'api';
import useHTTPError from 'hooks/useHTTPError';

/**
 * Uses the list of client reviews.
 */
const useClientReviews = () => {
  const { isLoading, error, data } = useQuery(
    'client-reviews',
    () => (
      api.fetchClientReviews()
    ), {
      staleTime: 5 * 60 * 1000
    }
  );

  useHTTPError(error);

  return {
    isLoading,
    result: data && data[0]
  };
};

export default useClientReviews;
